import { render, staticRenderFns } from "./EmailComposer.vue?vue&type=template&id=058d1c02&scoped=true"
import script from "./EmailComposer.vue?vue&type=script&lang=ts"
export * from "./EmailComposer.vue?vue&type=script&lang=ts"
import style0 from "./EmailComposer.vue?vue&type=style&index=0&id=058d1c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d1c02",
  null
  
)

export default component.exports